import { render, staticRenderFns } from "./check-gpa.vue?vue&type=template&id=e0e8b414&scoped=true&"
import script from "./check-gpa.vue?vue&type=script&lang=js&"
export * from "./check-gpa.vue?vue&type=script&lang=js&"
import style0 from "./check-gpa.vue?vue&type=style&index=0&id=e0e8b414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e8b414",
  null
  
)

export default component.exports